<template>
  <Pill :label="config.label" :bgColor="config.bg" :color="config.color" />
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { Pill } from ".";

import { StaffStatus } from "@/types";

interface Props {
  status?: StaffStatus;
}

const props = defineProps<Props>();

const statusMap: Partial<Record<StaffStatus, { bg: string; color: string; label: string }>> = {
  PENDING: { bg: "#E2A9171A", color: "#E2A917", label: "Pending" },
  UNVERIFIED: { bg: "##1C56911A", color: "var(--ch-blue-200)", label: "Unverified" },
  VERIFIED: { bg: "#E9FAEF", color: "var(--ch-secondary)", label: "Verified" },
  ACTIVE: { bg: "#E9FAEF", color: "var(--ch-secondary)", label: "Active" },
  INACTIVE: { bg: "#FF45001A", color: "#FF4500", label: "Inactive" },
  SUSPENDED: { bg: "#FFF0CB", color: "#A87E13", label: "Suspended" },
  REJECTED: { bg: "#AF39141A", color: "#AF3914", label: "Rejected" },
  EXPIRED: { bg: "#FF8C001A", color: "#FF8C00", label: "Expired" },
  ONHOLD: { bg: "#2125291A", color: "#212529", label: "Onhold" },
  INVITED: { bg: "var(--ch-light-blue-50)", color: "var(--ch-blue-100)", label: "Invited" },
};

const config = computed(() => {
  return statusMap[props?.status ?? 'ONHOLD'] ?? { 
    bg: "rgba(0,0,0,0.4)", 
    color: "rgba(0,0,0,0.8)", 
    label: `${props.status?.charAt(0)}${props.status?.slice(1).toLowerCase()}`
  };
});
</script>
